import { render, staticRenderFns } from "./WorkspaceMechanismAssociationScores.vue?vue&type=template&id=69a971ca&scoped=true"
import script from "./WorkspaceMechanismAssociationScores.vue?vue&type=script&lang=js"
export * from "./WorkspaceMechanismAssociationScores.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMechanismAssociationScores.vue?vue&type=style&index=0&id=69a971ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a971ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69a971ca')) {
      api.createRecord('69a971ca', component.options)
    } else {
      api.reload('69a971ca', component.options)
    }
    module.hot.accept("./WorkspaceMechanismAssociationScores.vue?vue&type=template&id=69a971ca&scoped=true", function () {
      api.rerender('69a971ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceMechanismAssociationScores.vue"
export default component.exports